import request from '@/blocks/request';

export function getJson(url, params) {
  return request({
    useLoading: true,
    url,
    params,
  });
}
